import { render } from "./MenuPopup.vue?vue&type=template&id=141c6567"
import script from "./MenuPopup.vue?vue&type=script&lang=js"
export * from "./MenuPopup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__